import moment from 'moment';
import { PAYNOW, PAYABLE } from '_utils/constant';

export const DEFAULT_EVENT_FORM_VALUES = {
  groupId: null,
  title: '',
  description: '',
  location: '',
  closingDate: moment().add(1, 'days').format('YYYY-MM-DD'),
  collectionDate: moment().add(1, 'weeks').format('YYYY-MM-DD'),
  timeFrom: '10:00',
  timeTo: '17:00',
  banners: [],
  paynow: PAYNOW,
  payable: PAYABLE,
  payTogether: true,
  payAfterClosing: false,
  adminCost: '',
  orderDiscountEnabled: false,
  orderDiscount: null,
  items: [
    {
      id: 1,
      name: '',
      description: '',
      price: '',
      image: null,
    },
  ],
  extraFields: [],
  enableSafeLinks: false,
  isDraft: false,
};
